import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Limit Order Submitted")
const _hoisted_2 = { class: "t-center flex-1 pt-32" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_ResultDialogTemplate = _resolveComponent("ResultDialogTemplate")

  return (_openBlock(), _createBlock(_component_ResultDialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "placeorder_38" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    controls: _withCtx(() => [
      _hoisted_3
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          name: "check",
          class: "bg-success my-20",
          style: {"font-size":"60px","color":"white","border-radius":"30px"}
        })
      ])
    ]),
    _: 1
  }))
}